import BlogSingle from "@/components/BlogDetails/BlogSingle";
import Seo from "@/components/seo/Seo";
import { getBlogSingle } from "@/redux/actions/blogDetailAction";
import { wrapper } from "@/redux/store";
import React from "react";
import { useSelector } from "react-redux";

export default function blogDetails() {
  const { blogSingle, error } = useSelector((state) => state.blogSingle);
  const seo = blogSingle[0]?.attributes?.seo;
  return (
    <>
      <Seo seo={seo} />
      <BlogSingle />
    </>
  );
}

/** For server side rendering */
export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ req, query }) => {
      // Get the menu data.

      // get the locations data.
      try {
        await store.dispatch(getBlogSingle(query.slug));
        return {
          props: {},
        };
      } catch (error) {
        console.log("blog", error);
      }
    }
);
